<template>
  <div class="py-4">
    <div v-if="!!stat.length" class="fade-in">
      Website View Stat
      <v-divider class="my-2"></v-divider>
      <v-row no-gutters>
        <v-card
          v-for="(n, i) in stat"
          :key="i"
          class="py-2 px-4 ma-2 fade-in"
          @click="graph.focus = graph.focus == i ? -1 : i"
          :ripple="false"
          min-width="164"
        >
          <v-card-title class="pa-0">Last {{ n.day }} day</v-card-title>
          <div class="text-subtitle-2">
            Distinct {{ parseInt(n.groupIp.view).toLocaleString() }} user
          </div>
          <div class="text-caption grey--text">
            Total {{ parseInt(n.noGroup).toLocaleString() }} view
          </div>

          <div
            v-if="graph.values[i]"
            style="position: relative"
            :class="i == 0 ? `white` : ``"
          >
            <v-sparkline
              :value="graph.values[i]"
              :color="(i == 0 ? graph.values[i][graph.currentHour] : stat[0].noGroup) >= graph.avgs[i] ? `green` : `red`"
              line-width="4"
              smooth="2"
              padding="4"
            ></v-sparkline>
            <div
              v-if="i == 0"
              style="position: absolute; top: 0; right: 0"
              :style="`width: calc(${
                100 * (1 - graph.currentHour / 23)
              }% - 2px)`"
              class="fill-height white"
            ></div>
          </div>
        </v-card>

        <v-card
          v-if="stat.length < days.length && !isLoading.stat"
          class="py-2 px-4 ma-2 text-center fade-in"
          @click="getStat"
          :ripple="false"
          min-width="164"
        >
          <v-card-title class="py-1 px-0">Show more</v-card-title>
          <v-icon class="mt-1">add</v-icon>
        </v-card>
      </v-row>
    </div>

    <v-sheet
      v-if="graph.focus != -1"
      class="mx-auto mt-4"
      elevation="2"
      max-width="600"
    >
      <div class="text-subtitle-1 text-center">
        Last {{ stat[graph.focus].day }} day, Peak
        {{ Math.max(...graph.values[graph.focus]) }}, Avg
        {{ graph.avgs[graph.focus] }}
      </div>
      <v-sparkline
        :labels="graph.focus != 3 ? [null] : []"
        :value="graph.values[graph.focus]"
        line-width="2"
        smooth="2"
        color="grey"
        padding="16"
        width="600"
        height="120"
      ></v-sparkline>
    </v-sheet>

    <div v-if="!!feedbacks.amount" class="mt-6 fade-in">
      User Feedback ( {{ feedbacks.amount }} )
      <v-divider class="my-2"></v-divider>
      <div
        class="pa-1 text-subtitle-2 d-flex flex-nowrap"
        v-for="{ _id, message, createdAt } in feedbacks.feedbacks"
        :key="_id"
      >
        <div class="shrink text-no-wrap pr-4">
          {{ new Date(createdAt).toLocaleString($langs.lang) }}
        </div>
        <div
          style="overflow-wrap: anywhere"
          v-html="message.replace(/</g, '&#60;').replace(/\n/g, '<br>')"
        ></div>
      </div>
      <v-btn
        v-if="feedbacks.feedbacks.length < feedbacks.amount"
        @click="getFeedback"
        :loading="isLoading.fb"
        small
        text
        :ripple="false"
        >Show more</v-btn
      >
    </div>

    <div v-else-if="!stat.length" class="font-weight-light fade-in">
      {{ $langs.Gen.loading[$langs.lang] }}...
    </div>
  </div>
</template>

<script>
import admin from "../../services/admin";
export default {
  data() {
    return {
      feedbacks: { amount: 0, feedbacks: [] },
      stat: [],
      isLoading: { stat: true, fb: true },
      days: [1, 7, 30, 90],

      graph: {
        focus: -1,
        values: [],
        avgs: [],
        currentHour: 0,
      },
    };
  },
  mounted() {
    admin.getFeedback({ countonly: true }).then((data) => {
      this.feedbacks.amount = data.amount;
      this.isLoading.fb = false;
    });
    this.getStat();
  },
  methods: {
    async getStat() {
      if (this.stat.length >= this.days.length) return;
      this.getRawStat();
      this.isLoading.stat = true;
      let data = await admin.getViewStat({ day: this.days[this.stat.length] });
      this.isLoading.stat = false;
      this.stat.push(data);
    },
    async getRawStat() {
      function daysInMonth(month, year) {
        return new Date(year, month, 0).getDate();
      }
      let day = this.days[this.stat.length];
      let { data, date } = await admin.getViewStat({ day }, true);

      let byDay = day != 1;
      let arr = Array(byDay ? day : 23).fill(0);
      let key, _key, _month;
      let _date = new Date(date).getDate();
      data.forEach(({ createdAt: dt }) => {
        let year = new Date(dt).getFullYear();
        let month = new Date(dt).getMonth();
        let day = new Date(dt).getDate();
        let hour = new Date(dt).getHours();

        key = byDay ? day : hour;
        if (_key == null) _key = byDay ? _date : hour;
        if (!_month) _month = month;
        let sumDaysInMonth = 0;
        for (let mm = _month; mm < month; mm++)
          sumDaysInMonth += daysInMonth(mm + 1, year);
        if (byDay)
          key = key + sumDaysInMonth;
        key = key - _key;

        arr[key]++;
      });
      let length = key + 1;
      let avg = (data.length / length).toFixed(2);

      if (!byDay) this.graph.currentHour = key;
      this.graph.avgs.push(avg);
      this.graph.values.push(arr);
    },
    async getFeedback() {
      const size = 10;
      const page = Math.ceil((this.feedbacks.feedbacks.length || 0) / size) + 1;
      this.isLoading.fb = true;
      let data = await admin.getFeedback({ size, page });
      this.isLoading.fb = false;
      this.feedbacks.feedbacks.push(...data.feedbacks);
    },
  },
};
</script>

<style>
</style>